"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useTimeout = function (duration) {
    var timeout = (0, react_1.useRef)(null);
    var start = function (callback) {
        cancel();
        timeout.current = setTimeout(callback, duration);
    };
    var cancel = function () {
        timeout.current && clearTimeout(timeout.current);
        timeout.current = null;
    };
    (0, react_1.useEffect)(function () {
        return function () { return cancel(); };
    }, []);
    return {
        start: start,
        cancel: cancel,
    };
};
exports.default = useTimeout;
